import React from "react"
import styled from "styled-components"
import { DateStartEndTimeFields } from "../../../designSystem/formField/DateStartEndTimeFields";
import { DateTimeStartEndFields } from "../../../designSystem/formField/DateTimeStartEndFields";
import { DateInput } from "../../../designSystem/inputs/DateInput";
import { StartEndDateFields } from "../../../designSystem/inputs/StartEndDateFields";
import { TimeInput } from "../../../designSystem/inputs/TimeInput";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";

export const DateTimeOverview = (): JSX.Element => 
{
    const [date, setDate] = React.useState(new Date());
    const [start, setStart] = React.useState(new Date());
    const [end, setEnd] = React.useState(new Date());

    return (
        <>
            <h2>Width options</h2>
            <Container>
                <Row>
                    <Flex flexDirection="column" gap={8} >
                        <DateInput
                            width="100%"
                            value={date} 
                            onValueChange={val => setDate(val)} />
                        
                        <DateInput
                            value={date} 
                            onValueChange={val => setDate(val)} />
                        
                        <DateInput
                            noBorder
                            value={date} 
                            onValueChange={val => setDate(val)} />
                    
                        <DateInput
                            value={date}
                            inErrorState={true}
                            onValueChange={val => setDate(val)} />
                    
                        <DateInput
                            value={date}
                            disabled={true}
                            onValueChange={val => setDate(val)} />
                        
                    </Flex>
                    <Flex flexDirection="column" gap={8}>
                        <TimeInput
                            width="100%"
                            value={date} 
                            onValueChange={val => setDate(val)} />
                        
                        <TimeInput
                            width="date-width"
                            value={date} 
                            onValueChange={val => setDate(val)} />
                        
                        <TimeInput
                            noBorder
                            width="date-width"
                            value={date} 
                            onValueChange={val => setDate(val)} />
                    
                        <TimeInput
                            value={date} 
                            onValueChange={val => setDate(val)} />
                    
                        <TimeInput
                            value={date}
                            inErrorState={true}
                            onValueChange={val => setDate(val)} />
                    
                        <TimeInput
                            value={date}
                            disabled={true}
                            onValueChange={val => setDate(val)} />
                    </Flex>
                </Row>

                <Flex flexDirection="column" gap={8}>
                <Row>
                    <Flex flexDirection="row" gap={8}>
                        <DateInput
                            value={date} 
                            onValueChange={val => setDate(val)} />
                        <TimeInput
                            width="time-width"
                            value={date} 
                            onValueChange={val => setDate(val)} />
                    </Flex>
                    </Row>
                <Row>
                    <Flex flexDirection="row" gap={8}>
                        <DateInput
                            value={date} 
                            onValueChange={val => setDate(val)} />
                        <TimeInput
                            width="date-width"
                            value={date} 
                            onValueChange={val => setDate(val)} />
                    </Flex>
                </Row>
                <Row>
                    <Flex flexDirection="row" gap={8}>
                        <DateInput
                            width="100%"
                            value={date}
                            onValueChange={val => setDate(val)} />
                        <TimeInput
                            width="100%"
                            value={date} 
                            onValueChange={val => setDate(val)} />
                    </Flex>
                </Row>
                </Flex>
            </Container>


            <h2>With clear button</h2>
            <Container>
                <Row>
                    <div>
                        <DateInput
                            showClearButton={true}
                            width="date-width"
                            value={date} 
                            onValueChange={val => setDate(val)} />
                        <DateInput
                            showClearButton={true}
                            width="date-width"
                            inErrorState={true}
                            value={date} 
                            onValueChange={val => setDate(val)} />
                        <DateInput
                            showClearButton={true}
                            width="date-width"
                            disabled={true}
                            value={date} 
                            onValueChange={val => setDate(val)} />
                    </div>
                </Row>
            </Container>
            <h2>Start to end</h2>
            <Container>
                <Flex flexDirection="row" gap={8}>
                    <div>
                        <StartEndDateFields 
                            start={start} end={end} 
                            onChanged={(start, end) => {
                                setStart(start);
                                setEnd(end);
                            }
                        } />
                    </div>
                </Flex>
            </Container>
            <h2>Date - Start to End time</h2>
            <Container>
                <Row>
                    <div>
                        <DateStartEndTimeFields
                            start={start} end={end} 
                            onChanged={(start, end) => {
                                setStart(start);
                                setEnd(end);
                            }
                        } />
                    </div>
                </Row>
            </Container>
            <h2>DateTimeStartEnd - Start to End date and time</h2>
            <Container>
                <Row>
                    <div>
                        <DateTimeStartEndFields
                            start={start} end={end} 
                            onChanged={(start, end) => {
                                setStart(start);
                                setEnd(end);
                            }
                        } />
                    </div>
                </Row>
            </Container>
        </>
    );
}

const Container = styled.div`
    margin-bottom: 20px;
    padding: 20px;
    border: 1px solid #888;
`;

const Row = styled.div`
    gap:20px;
    display: flex;
    flex-direction: row;
    align-items: top;

    & > * {
        flex: 1 1 0px;
    }
`;